(function() {
    'use strict';

    angular
        .module('atheer.system')
        .config(moduleConfig);

    function moduleConfig($stateProvider) {
        $stateProvider
            .state('storm.admin-audits', {
                url: '/settings/audits',
                templateUrl: 'modules/system/audits/audits.tmpl.html',
                controller: 'AuditsController',
                controllerAs: 'vm',
                data: {
                    pageTitle: 'atheer.audits.title',
                    layout: {
                        contentClass: 'layout-column',
                        footer: false
                    }
                },
                params: {
                    page: {
                        value: '1',
                        squash: true
                    },
                    sort: {
                        value: 'id,asc',
                        squash: true
                    },
                    search: null
                },
                resolve: {
                    pagingParams: ['$stateParams', 'PaginationUtil', function($stateParams, PaginationUtil) {
                        return {
                            page: PaginationUtil.parsePage($stateParams.page),
                            sort: $stateParams.sort,
                            predicate: PaginationUtil.parsePredicate($stateParams.sort),
                            ascending: PaginationUtil.parseAscending($stateParams.sort),
                            search: $stateParams.search
                        };
                    }]
                }
            });
    }
})();
